import Modal from 'react-modal'
import { getTextFromInfo } from '../../utils'

export default function MealPlanPopup({ isOpen, closeModal, description, iconClass, mealPlan }) {
  return (<Modal
    isOpen={isOpen}
    onRequestClose={closeModal}
    ariaHideApp={false}
    className='Modal react-popup form-popup'
    overlayClassName='Overlay'
    contentLabel='Booking enquire popup'>
    <span className='close-btn' onClick={closeModal} />
    <h2>
      <span>{getTextFromInfo(mealPlan, 'shop', 'RESORT_MEAL_PLANS')}</span>&nbsp;
      <i className={iconClass} />
    </h2>
    <div className='wysiwyg' dangerouslySetInnerHTML={{ __html: description }} />
  </Modal>)
}
